// @ts-nocheck
import './PayTypeIcon.scss'
import {defineComponent} from 'vue';
import {payTypeEnum} from "@/declares/options/payCenter/payTypeOptions";


class PayTypeIconProps {
  payType: number = null as any;
}


function PayTypeIcon(_props: any) {

  const props = _props as PayTypeIconProps;

  return () => <span class="pay-type-icon">
    {
      props.payType === payTypeEnum.wx ?
        <span>
        <i class="iconfont icon-wx-pay"/>
        <span class="pay-type-name">微信支付</span>
        </span>: null
    }
    {
      props.payType === payTypeEnum.alipay ?
        <span>
        <i class="iconfont icon-alipay"/>
        <span class="pay-type-name">支付宝支付</span>
        </span>: null
    }
    </span>
}


export default defineComponent({
  props: {
    payType: {type: Number, required: true}
  },
  setup: PayTypeIcon
});
